import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

// Project images
import XpertAid from "../../Assets/Projects/FYP.png";
import ArtSpark from "../../Assets/Projects/Artspark.png";
import fire from "../../Assets/Projects/fire.png";
import emotion from "../../Assets/Projects/emotion.png";
import suicide from "../../Assets/Projects/suicide.png";
import Sticky_Notes from "../../Assets/Projects/Sticky_Notes.png";
import KittyKorner from "../../Assets/Projects/KittyKorner.png";
import Simon_game from "../../Assets/Projects/Simon_game.png";
import Dicee_game from "../../Assets/Projects/Dicee_game.png";
import TailwindFrontend from "../../Assets/Projects/TailwindFrontend.png";
import Tic_tac_toe_game from "../../Assets/Projects/Tic_tac_toe_game.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Featured <strong className="purple">Projects</strong>
        </h1>
        <p style={{ color: "white" }}>
          These are two major academic & industry-level projects I've built
          recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={6} className="project-card">
            <ProjectCard
              imgPath={XpertAid}
              isBlog={false}
              title="Xpert-Aid (FYP)"
              imgStyle={{ height: "350px", objectFit: "cover" }}
              description="A MERN-based AI medical diagnostic system that detects 11 diseases: 3 via CNN on images and 8 via Random Forest on CSV clinical data. Features include secure logins for patients/doctors/admins, health prediction via symptoms, email OTP, appointment system, and admin dashboard. Real-time ML integration enhances diagnosis and accessibility."
              demoLink="https://xpert-aid-frontend.vercel.app"
            />
          </Col>

          <Col md={6} className="project-card">
            <ProjectCard
              imgPath={ArtSpark}
              isBlog={false}
              title="ArtSpark (Flutter)"
              imgStyle={{ height: "350px", objectFit: "cover" }}
              description="A Flutter + Firebase AR-based art marketplace where artists manage their storefronts, upload artworks, and monitor orders with analytics. Buyers can preview products using Google ARCore, add to cart, and place orders. Features seller dashboards, cash-on-delivery, and customer order history system."
              demoLink="https://drive.google.com/uc?export=download&id=1GMr35RTMb2--EEke_gNX-vpxy4goG3RC"
            />
          </Col>
        </Row>

        <h1 className="project-heading">
          More <strong className="purple">Projects</strong>
        </h1>
        <p style={{ color: "white" }}>
          Additional projects that demonstrate my frontend, backend, and AI
          skills.
        </p>

        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Sticky_Notes}
              isBlog={false}
              title="Sticky Notes"
              description="A React + Node.js SPA for managing sticky notes with title, description, and delete functionality. Clean UI, local storage integration, and efficient note handling."
              ghLink="https://github.com/faseeh41/Sticky-Notes-React"
              demoLink="https://sticky-notes-react-faseeh.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={TailwindFrontend}
              isBlog={false}
              title="Tailwind Frontend"
              description="A fast static site built with Tailwind CSS and Vite, enabling rapid prototyping and clean, responsive UI using utility-first classes."
              ghLink="https://github.com/faseeh41/Tailwind_frontend"
              demoLink="https://tailwind-frontend-faseeh.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={KittyKorner}
              isBlog={false}
              title="Kitty Korner"
              description="A cat-themed Bootstrap website offering feline content and adopt/buy links. Styled responsively for smooth UX and engaging interaction."
              ghLink="https://github.com/faseeh41/KittyKorner-Bootstrap"
              demoLink="https://kitty-korner-faseeh.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={fire}
              isBlog={false}
              title="Fire Detection and Email Alert"
              description="Fire detection using YOLOv8. Users input an email; if fire is detected in a frame, an automatic alert is sent to that email with fire evidence attached."
              ghLink="https://github.com/faseeh41/Fire-Detection-Using-YOLOV8"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="AI for Social Good"
              description="An NLP model to detect suicide-related posts from social media, trained to flag ideation using sentiment analysis and key phrase extraction for mental health response."
              ghLink="https://github.com/faseeh41/AI_For_Social_Good"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Emotion Detection via Face"
              description="Trained a CNN using FER-2013 dataset to detect 7 facial emotions. Achieved 60.1% accuracy. Combined with OpenCV for face detection in real-time video feed."
              ghLink="https://github.com/faseeh41/Face_And_Emotion_Detection"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Simon_game}
              isBlog={false}
              title="Simon Game"
              description="Built with HTML/CSS/JS, Simon Game challenges users to repeat color-sound sequences. Great UI/UX, memory-focused gameplay, responsive and fun."
              ghLink="https://github.com/faseeh41/Simon-Game-"
              demoLink="https://simon-game-liart-faseeh.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Tic_tac_toe_game}
              isBlog={false}
              title="Tic-Tac-Toe Game"
              description="Interactive tic-tac-toe game for 2 players. 3x3 grid logic, win/draw detection, and basic animation. Built with HTML/CSS/JS."
              ghLink="https://github.com/faseeh41/Tic-Tac-Toe-Game"
              demoLink="https://tic-tac-toe-game-faseeh.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Dicee_game}
              isBlog={false}
              title="Dicee Game"
              description="Simple 2-player dice game using random number generation. Refresh to roll, compare results, and determine winner. Fun frontend game!"
              ghLink="https://github.com/faseeh41/Dicee-Game"
              demoLink="https://dicee-game-faseeh.vercel.app/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
